export enum SubsectionButtonOption {
  BROWSE = 'browse',
  SUPPLY = 'customerSupplied',
  NONE = 'none',
}
